// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { LMModel } from '@form/model';
import { LMContextService } from '@app/services';
import { SohoTooltipDirective } from 'ids-enterprise-ng';

@Component({
  selector:    'lm-mouse-over-text',
  template: `
      <ng-container *ngIf="isMobile; else BrowserMouseOverTextIcon">
        <span soho-tooltip
            class="lm-mouse-over-span"
            extraClass="lm-field-mouse-over-text"
            [beforeShow]="displayMouseOverText"
            trigger="click"
            (click)="mouseOverTextClick($event)"
        ><svg soho-icon icon="info" class="lm-mouse-over-icon"></svg></span>
      </ng-container>
      <ng-template #BrowserMouseOverTextIcon>
        <span soho-tooltip
            class="lm-mouse-over-span"
            extraClass="lm-field-mouse-over-text"
            delay="100"
            [beforeShow]="displayMouseOverText"
        ><svg soho-icon icon="info" class="lm-mouse-over-icon"></svg></span>
      </ng-template>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LMMouseOverTextComponent implements OnInit {
  @Input() mouseOverTextContents: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Input() beforeShowTooltip: Function;

  @ViewChild(SohoTooltipDirective) tooltip: SohoTooltipDirective;

  public isMobile = false;

  constructor(
    private lmContextService: LMContextService,
  ) {}

  ngOnInit() {
    this.isMobile = this.lmContextService.isMobileDevice();
  }

  // Stops the click event from propagating up when opening help text on mobile
  public mouseOverTextClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.tooltip.show();
  }

  displayMouseOverText = (response: any) => {
    if (this.beforeShowTooltip) {
      this.beforeShowTooltip(response);
    } else {
      response(this.mouseOverTextContents);
    }
  }
}
